// A4 list size
// landscape
// height 0 - 1140 px
// width 0 - ?
// portrait
// height 0 - ?
// width 0 - 1140 px

import * as React from 'react'
import {connect} from 'react-redux'
import {v4 as uuidv4} from 'uuid'
import {Collapsible} from '../../core/components/Controls/Collapsible/Collapsible'
import {CoordinateSystem} from '../../core/enums/CoordinateSystem'
import {DrawSource} from '../../core/enums/DrawSource'
import {DrawType} from '../../core/enums/DrawType'
import {OnClickAction} from '../../core/enums/MapEvents'
import {IExportMapDispatcher, IMapDispatcher} from '../../core/interfaces/dispatchers'
import {PageSize} from '../../core/interfaces/models'
import {IExportLayouts, IExportMap, IFeatureLayerInfos} from '../../core/interfaces/reducers'
import {Feature, Point, Polygon, VectorLayer} from '../../core/models'
import {getMapService} from '../../core/reducers/map'
import {ServiceHub} from '../../core/ServiceHub'
import {appExportMapDispatcher} from '../../dispatchers/appExportMapDispatcher'
import {appMapDispatcher} from '../../dispatchers/appMapDispatcher'
import {IAppStore} from '../../interfaces/reducers'
import appConfig from '../../reducers/appConfig'
import {LocationSelector} from '../App/LocationSelector'
import AppExportMapControl from '../Map/AppExportMapControl'
import Axios from 'axios'
import merge from 'lodash/merge'
import {config} from '../../core/reducers/config'

export interface OwnProps {
  exportMapStore: IExportMap
  layerInfos: IFeatureLayerInfos
  selectedExport: string
}

export interface ParentProps {}

export interface DispatchProps extends IExportMapDispatcher, IMapDispatcher {}

export type Props = OwnProps & ParentProps & DispatchProps
type selectTYpes =
  | 'regular'
  | 'izvadka'
  | 'kombinirana'
  | 'trasirovuchen'
  | 'izvadka2'
  | 'prn_izvadka'
  | 'combined'
  | 'upicoordinates'
  | 'visa'
  | 'custom'
  | 'upi-oup'

interface State {
  selectedExport: selectTYpes
  selectedLocation?: Feature
  selectedSet?: Feature
  selectedParcel?: Feature
  trasCoordinates: Feature[]
  rotating: boolean
  coordinateCorrectionsOpen: boolean
  fromToForDelete: number[]
}

export class AppExportSelector extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      selectedExport: 'izvadka',
      trasCoordinates: [],
      rotating: false,
      coordinateCorrectionsOpen: true,
      fromToForDelete: [1, 1]
    }
  }
  componentWillUnmount() {
    this.clearpointsource()
    this.props.setMapOnClick(OnClickAction.Popup)
    const mapService = getMapService()
    if (mapService) {
      mapService.startClickEvent()
      mapService.drawing.unMark(DrawSource.ExportSelect)
    }
  }
  upiDrawActivated = false
  activateUpiIdentDraw() {
    this.upiDrawActivated = true
    getMapService().drawing.activateDraw(
      DrawType.Point,
      DrawSource.ExportExtent,
      () => {
        this.upiDrawActivated = false
      },
      geomf => {
        this.props.setHardLoading(true)
        const coordinates = geomf.getGeometry().getCoordinates() as any
        setTimeout(() => {
          const poly = new Polygon([
            [
              [coordinates[0] + 1, coordinates[1] + 1],
              [coordinates[0] + 1, coordinates[1] - 1],
              [coordinates[0] - 1, coordinates[1] - 1],
              [coordinates[0] - 1, coordinates[1] + 1]
            ]
          ])

          ServiceHub.gisCrudService
            .execute(this.props.layerInfos[appConfig.reg.parcels.parcelsUrl], {
              where: '"OverriddenByRegPlanId" IS NULL',
              geometry: poly
            })
            .then(feats => {
              if (feats.length > 0) {
                // take the latest feature as we expect it to be a newest
                const latestFeat = feats[feats.length - 1]
                getMapService().panTo(latestFeat.getGeometry())
                ServiceHub.BgTransService.bgTrans(CoordinateSystem.BG2005CAD, latestFeat.getGeometry()).then(transd => {
                  latestFeat.set('BgGeom', transd)
                  this.props.setHardLoading(false)
                  this.props.setFeatures([
                    {
                      layerInfo: this.props.layerInfos[appConfig.reg.parcels.parcelsUrl],
                      features: [latestFeat]
                    }
                  ])
                })
              } else {
                this.clearpointsource()
                this.props.setHardLoading(false)
                this.activateUpiIdentDraw()
              }
            })
            .catch(eeee => {
              this.clearpointsource()
              this.props.setHardLoading(false)
            })
        }, 100)
      }
    )
  }

  componentDidMount() {
    this.props.setMapOnClick(OnClickAction.Disabled)
    getMapService().stopClickEvent()
    this.setExportType(this.state.selectedExport)
  }

  componentDidUpdate(prevProps: Props) {
    const customExportsString = localStorage.getItem('CustomExports')
    if (!customExportsString) {
      Axios.get(config.getConfig().urls.xyApiUrl + '/AdminAccount/getCustomExports')
        .then(response => {
          const data = JSON.parse(response.data['CustomExports'])
          for (const key in data) {
            localStorage.setItem(key, data[key])
          }
          localStorage.setItem('CustomExports', 'true')
        })
        .catch(error => {
          console.log(error)
        })
    }

    if (
      prevProps.exportMapStore.features !== this.props.exportMapStore.features &&
      this.props.exportMapStore.features &&
      (this.state.selectedExport == 'izvadka2' ||
        this.state.selectedExport == 'upicoordinates' ||
        this.state.selectedExport == 'visa' ||
        this.state.selectedExport == 'upi-oup')
    ) {
      const parcelFeats = this.props.exportMapStore.features
        ? this.props.exportMapStore.features.find(
            t => t.layerInfo.sourceDescription.id == appConfig.reg.parcels.parcelsUrl
          )
        : undefined
      if (parcelFeats) {
        if (parcelFeats.features.length > 0) {
          const feat = parcelFeats.features[0]
          getMapService().drawing.mark([feat], DrawSource.ExportSelect)

          if (!this.state.selectedParcel || feat.guid != this.state.selectedParcel.guid) {
            const trasPoints = this.setUpiPoints(feat)
            this.setState(
              {
                ...this.state,
                selectedParcel: feat,
                trasCoordinates: trasPoints
              },
              () => {
                this.setExportType(this.state.selectedExport)
              }
            )
          }
        } else {
          this.setState({...this.state, selectedParcel: undefined, trasCoordinates: []}, () => {
            getMapService().updateSize()
            this.activateUpiIdentDraw()
          })
        }
      } else {
        this.setState({...this.state, selectedParcel: undefined, trasCoordinates: []}, () => {
          getMapService().updateSize()
          this.activateUpiIdentDraw()
        })
      }
    }
  }

  getUpiCoordsIzvadka(): IExportLayouts {
    return {
      A4: {
        portrait: {
          elements: {
            legend: {
              resizibleHeight: 469,
              resizibleWidth: 990,
              resizibleLeft: 52,
              resizibleTop: 1110,
              type: 'legend',
              hide: true
            },
            scale: {
              resizibleHeight: 38,
              resizibleLeft: 453,
              resizibleTop: 1217,
              resizibleWidth: 197,
              type: 'scale',
              hide: true
            },
            remark: {
              resizibleHeight: 38,
              resizibleLeft: 453,
              resizibleTop: 1217,
              resizibleWidth: 197,
              text: `<p style="font-size: 14px;">Забележка: Скицата не е мащабна, а ориентировъчна</p>`,
              type: 'text'
            },
            header: {
              resizibleHeight: 147,
              resizibleLeft: 106,
              resizibleTop: 23.999999999999986,
              resizibleWidth: 371,
              type: 'text',
              text: `<p><span style="font-size: 24px;">ОБЩИНА {Municipality}</span></p>\n<p>Дирекция \"Устройство на територията\"</p>\n<p>Отдел \"Устройствено планиране\"</p>\n<p>№</p>`,
              textHeightMM: 3
            },
            freeText: {
              resizibleHeight: 86,
              resizibleLeft: 102,
              resizibleTop: 307,
              resizibleWidth: 950,
              text: `<p>Във връзка с Ваше Искане № ..........................................Дирекция "<span style="color: rgb(0,0,0);font-size: 20px;">УТ</span>" при Община {Municipality}, Ви предоставя исканите координати за УПИ {ParcelNumber}, {QuarterNumber}  по плана на {SettlementName}, общ. {Municipality}</p>`,
              textHeightMM: 3,
              type: 'text'
            },
            to: {
              resizibleHeight: 143,
              resizibleLeft: 109.99999999999989,
              resizibleTop: 163,
              resizibleWidth: 382,
              text: `<p>ДО</p><p>............................................</p><p>............................................</p><p>............................................</p><p>............................................</p>`,
              textHeightMM: 3,
              type: 'text'
            },
            footer1: {
              resizibleHeight: 126,
              resizibleWidth: 278,
              resizibleLeft: 774.9999999999999,
              resizibleTop: 1396.7600097656248,
              type: 'text',
              text: '<p style="text-align:left;">Заверил:</p>\n<p style="text-align:left;">Началник "УП".................................</p>\n<p style="text-align:right;">........</p>\n',
              textHeightMM: 3
            },
            coordinates: {
              resizibleHeight: 360,
              resizibleLeft: 101,
              resizibleTop: 1213,
              resizibleWidth: 294,
              type: 'text',
              text: '{Coordinates}',
              textHeightMM: 3
            },
            footer2: {
              resizibleHeight: 118,
              resizibleWidth: 286,
              resizibleLeft: 775.9999999999999,
              resizibleTop: 1486.7600097656248,
              type: 'text',
              text: '<p style="text-align:left;">Изчертал:</p>\n<p style="text-align:left;">Гл. експерт "УП".............................</p>\n<p style="text-align:right;">........</p>\n',
              textHeightMM: 3
            }
          },
          mapProps: {
            resizibleHeight: 783,
            resizibleLeft: 82,
            resizibleTop: 429,
            resizibleWidth: 960
          },
          margins: [36, 36, 36, 36],
          zoomFactor: 0.5
        },
        landscape: {
          elements: {
            scale: {
              resizibleHeight: 64,
              resizibleWidth: 311,
              resizibleLeft: 377,
              resizibleTop: 119,
              type: 'scale',
              hide: false
            },
            legend: {
              resizibleHeight: 469,
              resizibleWidth: 990,
              resizibleLeft: 52,
              resizibleTop: 1110,
              type: 'legend',
              hide: true
            },
            header: {
              resizibleHeight: 118,
              resizibleWidth: 384,
              resizibleLeft: 346.66666666666663,
              resizibleTop: 31.999999999999986,
              type: 'text',
              text: `<p style="text-align:center;"><span style="font-size: 24px;">КОПИЕ СКИЦА - ИЗВАДКА</span></p>
                            <p style="text-align:center;"><span style="font-size: 24px;">от ......................</span></p>
                            <p style="text-align:center;"><span style="font-size: 24px;">на {Name}, Община {Municipality}</span></p>`,
              textHeightMM: 3
            },
            date: {
              resizibleHeight: 81,
              resizibleWidth: 246,
              resizibleLeft: 37.99999999999999,
              resizibleTop: 1501.9999999999998,
              type: 'text',
              text: '<p>' + +' г.</p>',
              textHeightMM: 3
            },
            madeBy: {
              resizibleHeight: 81,
              resizibleWidth: 285,
              resizibleLeft: 754.6666666666665,
              resizibleTop: 1496.333333333333,
              type: 'text',
              text: `<p style="text-align:right;">Изработил: {username}</p>
                            <p style="text-align:right;">/_________________________/</p>`,
              textHeightMM: 3
            }
          },
          mapProps: {
            resizibleHeight: 1200,
            resizibleWidth: 1000,
            resizibleLeft: 50,
            resizibleTop: 200
          },
          margins: [36, 36, 36, 36],
          zoomFactor: 0.9
        }
      }
    }
  }

  getPrnIzvadka(): IExportLayouts {
    return {
      A3: {
        portrait: {
          elements: {
            scale: {
              resizibleHeight: 30,
              resizibleWidth: 208,
              resizibleLeft: 778,
              resizibleTop: 67,
              type: 'scale',
              hide: false
            },
            legend: {
              resizibleHeight: 469,
              resizibleWidth: 990,
              resizibleLeft: 52,
              resizibleTop: 1110,
              type: 'legend',
              hide: true
            },
            date: {
              resizibleHeight: 57,
              resizibleWidth: 225,
              resizibleLeft: 169,
              resizibleTop: 2202,
              type: 'text',
              text: '<p>{date}</p>',
              textHeightMM: 3
            },
            '128cd227-21aa-4178-94e5-06b2886731c6': {
              resizibleHeight: 120,
              resizibleWidth: 215,
              resizibleLeft: 131.3333333333333,
              resizibleTop: 106.33333333333329,
              type: 'text',
              text:
                '<p style="text-align:left;">Община {Municipality}</p>\n<p style="text-align:left;">Д-я "Управление на територията"</p>\n<p style="text-align:left;">№ ..../' +
                this.getMounth() +
                ' ' +
                new Date().getFullYear().toString() +
                '</p>\n',
              textHeightMM: 3
            },
            'dd37da44-2f67-4837-8264-92e0712a7a55': {
              resizibleHeight: 111,
              resizibleWidth: 903,
              resizibleLeft: 592.9999999999997,
              resizibleTop: 111.66666666666657,
              type: 'text',
              text: '<p style="text-align:justify;">Скаца - извадка от действащия ПНИ за ПИ ..., по плана на ....., землище ...., гр. {Municipality} одобрен със заповед № ..../....г. на .......</p>\n',
              textHeightMM: 3
            },
            '5dd0a82d-82e7-4703-890a-b42fb885131a': {
              resizibleHeight: 115,
              resizibleWidth: 513,
              resizibleLeft: 731.3333333333331,
              resizibleTop: 226.9999999999999,
              type: 'text',
              text: '<p style="text-align:left;">ПИ 473 е с площ ...кв.м</p>\n<p style="text-align:left;">ПИ 474 е с площ ...кв.м</p>\n',
              textHeightMM: 3
            },
            '98dc270b-2105-4b76-bb3e-436a7013ee95': {
              resizibleHeight: 130,
              resizibleWidth: 888,
              resizibleLeft: 606.9999999999999,
              resizibleTop: 359.99999999999983,
              type: 'text',
              text: '<p style="text-align:left;">Скица № 15-40106-17.01.2020г. и скица № 15-40104-17.01.2020г. на СГКК е неразделна част от скица № 23/03.04.2017г. на Дирекция "ЦАУ Възрадане"</p>\n',
              textHeightMM: 3
            },
            'c8a573a5-5926-4614-bc82-853e88698246': {
              resizibleHeight: 68,
              resizibleWidth: 285,
              resizibleLeft: 609,
              resizibleTop: 469.33333333333314,
              type: 'text',
              text: '<p style="text-align:left;">важи: служебна за проектиране</p>\n',
              textHeightMM: 3
            },
            '96baab99-6f9f-44a3-9b5d-390cf584bc0e': {
              resizibleHeight: 99,
              resizibleWidth: 205,
              resizibleLeft: 1306.333333333333,
              resizibleTop: 2048.6666666666656,
              type: 'text',
              text: '<p style="text-align:right;"></p>\n<p style="text-align:right;"><span style="color: rgb(0,0,0);font-size: 14px;">Изработил: {username} </span></p>\n<p style="text-align:right;"></p>\n<p style="text-align:right;"><span style="color: rgb(0,0,0);font-size: 14px;">/_________________________/</span>&nbsp;</p>\n',
              textHeightMM: 3
            },
            'af12b3d6-816a-45f2-80b9-98c0c08ec264': {
              resizibleHeight: 94,
              resizibleWidth: 200,
              resizibleLeft: 1307.6666666666663,
              resizibleTop: 2149.333333333332,
              type: 'text',
              text: '<p style="text-align:right;"></p>\n<p style="text-align:right;"><span style="color: rgb(0,0,0);font-size: 14px;">Проверил:................................... </span></p>\n<p style="text-align:right;"></p>\n<p style="text-align:right;"><span style="color: rgb(0,0,0);font-size: 14px;">/_________________________/</span>&nbsp;</p>\n',
              textHeightMM: 3
            },
            '16c279ae-6f08-43c4-b3c7-856f639e6f88': {
              resizibleHeight: 87,
              resizibleWidth: 199,
              resizibleLeft: 1308,
              resizibleTop: 2225.9999999999995,
              type: 'text',
              text: '<p style="text-align:right;"><span style="color: rgb(0,0,0);font-size: 14px;">Изчислил:................................... </span></p>\n<p style="text-align:right;"><span style="color: rgb(0,0,0);font-size: 14px;">/_________________________/</span>&nbsp;</p>\n',
              textHeightMM: 3
            }
          },
          margins: [36, 36, 36, 36],
          zoomFactor: 0.5,
          mapProps: {
            resizibleHeight: 1500,
            resizibleWidth: 1500,
            resizibleLeft: 50,
            resizibleTop: 500
          }
        },
        landscape: {
          mapProps: {
            resizibleHeight: 1072,
            resizibleWidth: 2128,
            resizibleLeft: 102,
            resizibleTop: 389
          },
          margins: [36, 36, 36, 36],
          zoomFactor: 0.5,
          elements: {
            scale: {
              resizibleHeight: 30,
              resizibleWidth: 208,
              resizibleLeft: 1069,
              resizibleTop: 48,
              type: 'scale',
              hide: false
            },
            legend: {
              resizibleHeight: 469,
              resizibleWidth: 990,
              resizibleLeft: 52,
              resizibleTop: 1110,
              type: 'legend',
              hide: true
            },
            date: {
              resizibleHeight: 57,
              resizibleWidth: 225,
              resizibleLeft: 144,
              resizibleTop: 1480.9566461555728,
              type: 'text',
              text: '<p>{date}</p>',
              textHeightMM: 3
            },
            '128cd227-21aa-4178-94e5-06b2886731c6': {
              resizibleHeight: 120,
              resizibleWidth: 215,
              resizibleLeft: 131.3333333333333,
              resizibleTop: 106.33333333333329,
              type: 'text',
              text: '<p style="text-align:left;">Община {Municipality} </p>\n<p style="text-align:left;">Д-я "Управление на територията"</p>\n<p style="text-align:left;">№ ..../10.04.2020г.</p>\n',
              textHeightMM: 3
            },
            'dd37da44-2f67-4837-8264-92e0712a7a55': {
              resizibleHeight: 86,
              resizibleWidth: 1546,
              resizibleLeft: 653.9999999999995,
              resizibleTop: 114.66666666666657,
              type: 'text',
              text: '<p style="text-align:justify;">Скаца - извадка от действащия ПНИ за ПИ ..., по плана на ....., землище ...., гр. {Municipality} одобрен със заповед № ..../....г. на .......</p>\n',
              textHeightMM: 3
            },
            '5dd0a82d-82e7-4703-890a-b42fb885131a': {
              resizibleHeight: 115,
              resizibleWidth: 513,
              resizibleLeft: 751.3333333333331,
              resizibleTop: 182.9999999999999,
              type: 'text',
              text: '<p style="text-align:left;">ПИ 473 е с площ ...кв.м</p>\n<p style="text-align:left;">ПИ 474 е с плщо ...кв.м</p>\n',
              textHeightMM: 3
            },
            '98dc270b-2105-4b76-bb3e-436a7013ee95': {
              resizibleHeight: 52,
              resizibleWidth: 1541,
              resizibleLeft: 655.9999999999999,
              resizibleTop: 259.99999999999983,
              type: 'text',
              text: '<p style="text-align:left;">Скица № 15-40106-17.01.2020г. и скица № 15-40104-17.01.2020г. на СГКК е неразделна част от скица № 23/03.04.2017г. на Дирекция "ЦАУ Възрадане"</p>\n',
              textHeightMM: 3
            },
            'c8a573a5-5926-4614-bc82-853e88698246': {
              resizibleHeight: 68,
              resizibleWidth: 285,
              resizibleLeft: 703,
              resizibleTop: 307.33333333333314,
              type: 'text',
              text: '<p style="text-align:left;">важи: служебна за проектиране</p>\n',
              textHeightMM: 3
            },
            '96baab99-6f9f-44a3-9b5d-390cf584bc0e': {
              resizibleHeight: 99,
              resizibleWidth: 205,
              resizibleLeft: 1760.333333333333,
              resizibleTop: 1488.9566461555728,
              type: 'text',
              text: '<p style="text-align:right;"></p>\n<p style="text-align:right;"><span style="color: rgb(0,0,0);font-size: 14px;">Изработил: {username} </span></p>\n<p style="text-align:right;"></p>\n<p style="text-align:right;"><span style="color: rgb(0,0,0);font-size: 14px;">/_________________________/</span>&nbsp;</p>\n',
              textHeightMM: 3
            },
            'af12b3d6-816a-45f2-80b9-98c0c08ec264': {
              resizibleHeight: 94,
              resizibleWidth: 200,
              resizibleLeft: 1491.6666666666663,
              resizibleTop: 1486.9566461555728,
              type: 'text',
              text: '<p style="text-align:right;"></p>\n<p style="text-align:right;"><span style="color: rgb(0,0,0);font-size: 14px;">Проверил:................................... </span></p>\n<p style="text-align:right;"></p>\n<p style="text-align:right;"><span style="color: rgb(0,0,0);font-size: 14px;">/_________________________/</span>&nbsp;</p>\n',
              textHeightMM: 3
            },
            '16c279ae-6f08-43c4-b3c7-856f639e6f88': {
              resizibleHeight: 87,
              resizibleWidth: 199,
              resizibleLeft: 2044,
              resizibleTop: 1493.9566461555728,
              type: 'text',
              text: '<p style="text-align:right;"><span style="color: rgb(0,0,0);font-size: 14px;">Изчислил:................................... </span></p>\n<p style="text-align:right;"><span style="color: rgb(0,0,0);font-size: 14px;">/_________________________/</span>&nbsp;</p>\n',
              textHeightMM: 3
            }
          }
        }
      }
    }
  }

  getCombinedPlan(): IExportLayouts {
    return {
      A4: {
        portrait: {
          elements: {
            scale: {
              resizibleHeight: 64,
              resizibleWidth: 311,
              resizibleLeft: 593,
              resizibleTop: 109,
              type: 'scale',
              hide: false
            },
            legend: {
              resizibleHeight: 469,
              resizibleWidth: 990,
              resizibleLeft: 52,
              resizibleTop: 1110,
              type: 'legend',
              hide: true
            },
            header: {
              resizibleHeight: 118,
              resizibleWidth: 384,
              resizibleLeft: 694.6666666666666,
              resizibleTop: 27.999999999999986,
              type: 'text',
              text: '<p style="text-align:left;"><span style="font-size: 24px;"><strong>ОБЩИНА {Municipality}</strong></span></p>\n<p style="text-align:left;"><span style="font-size: 24px;"><strong>Комбиниране скица</strong></span></p>\n<p style="text-align:left;"><span style="font-size: 24px;"><strong>№ .../{date}</strong></span></p>\n',
              textHeightMM: 3
            },
            date: {
              resizibleHeight: 81,
              resizibleWidth: 246,
              resizibleLeft: 107,
              resizibleTop: 1494.9999999999998,
              type: 'text',
              text: '<p>{date}</p>',
              textHeightMM: 3
            },
            madeBy: {
              resizibleHeight: 81,
              resizibleWidth: 285,
              resizibleLeft: 754.6666666666665,
              resizibleTop: 1496.333333333333,
              type: 'text',
              text: '<p style="text-align:right;">Изработил: {username}</p>\n                            <p style="text-align:right;">/_________________________/</p>',
              textHeightMM: 3
            },
            '072e57c5-873f-408f-b770-11b5e853b76f': {
              resizibleHeight: 133,
              resizibleWidth: 515,
              resizibleLeft: 525.9999999999999,
              resizibleTop: 172.99999999999994,
              type: 'text',
              text: '<p style="text-align:justify;">от действащ ПУП-ПЗ за част от ................</p>\n',
              textHeightMM: 3
            }
          },
          margins: [36, 36, 36, 36],
          zoomFactor: 0.5,
          mapProps: {
            resizibleHeight: 1158,
            resizibleWidth: 963,
            resizibleLeft: 83,
            resizibleTop: 318
          }
        },
        landscape: {
          mapProps: {
            resizibleHeight: 1158,
            resizibleWidth: 963,
            resizibleLeft: 83,
            resizibleTop: 318
          },
          margins: [36, 36, 36, 36],
          zoomFactor: 0.5,
          elements: {
            scale: {
              resizibleHeight: 64,
              resizibleWidth: 311,
              resizibleLeft: 593,
              resizibleTop: 109,
              type: 'scale',
              hide: false
            },
            legend: {
              resizibleHeight: 469,
              resizibleWidth: 990,
              resizibleLeft: 52,
              resizibleTop: 1110,
              type: 'legend',
              hide: true
            },
            header: {
              resizibleHeight: 118,
              resizibleWidth: 384,
              resizibleLeft: 694.6666666666666,
              resizibleTop: 27.999999999999986,
              type: 'text',
              text:
                '<p style="text-align:left;"><span style="font-size: 24px;"><strong>ОБЩИНА {Municipality}</strong></span></p>\n<p style="text-align:left;"><span style="font-size: 24px;"><strong>Комбиниране скица</strong></span></p>\n<p style="text-align:left;"><span style="font-size: 24px;"><strong>№ .../' +
                this.getDay() +
                '.' +
                this.getMounthNumber() +
                '.' +
                new Date().getFullYear().toString() +
                ' г.</strong></span></p>\n',
              textHeightMM: 3
            },
            date: {
              resizibleHeight: 81,
              resizibleWidth: 246,
              resizibleLeft: 107,
              resizibleTop: 1494.9999999999998,
              type: 'text',
              text: '<p>Октомври 2020 г.</p>',
              textHeightMM: 3
            },
            madeBy: {
              resizibleHeight: 81,
              resizibleWidth: 285,
              resizibleLeft: 754.6666666666665,
              resizibleTop: 1496.333333333333,
              type: 'text',
              text: '<p style="text-align:right;">Изработил: {username}</p>\n                            <p style="text-align:right;">/_________________________/</p>',
              textHeightMM: 3
            },
            '072e57c5-873f-408f-b770-11b5e853b76f': {
              resizibleHeight: 133,
              resizibleWidth: 515,
              resizibleLeft: 525.9999999999999,
              resizibleTop: 172.99999999999994,
              type: 'text',
              text: '<p style="text-align:justify;">от действащ ПУП-ПЗ за част от ................</p>\n',
              textHeightMM: 3
            }
          }
        }
      }
    }
  }

  getIzvadkaLayouts(): IExportLayouts {
    const content: IExportLayouts = {
      A4: {
        landscape: {
          elements: {
            scale: {
              resizibleHeight: 64,
              resizibleWidth: 311,
              resizibleLeft: 377,
              resizibleTop: 119,
              type: 'scale',
              hide: false
            },
            legend: {
              resizibleHeight: 469,
              resizibleWidth: 990,
              resizibleLeft: 52,
              resizibleTop: 1110,
              type: 'legend',
              hide: true
            },
            header: {
              resizibleHeight: 118,
              resizibleWidth: 384,
              resizibleLeft: 346.66666666666663,
              resizibleTop: 31.999999999999986,
              type: 'text',
              text: `<p style="text-align:center;"><span style="font-size: 24px;">КОПИЕ СКИЦА - ИЗВАДКА</span></p>
                            <p style="text-align:center;"><span style="font-size: 24px;">от ......................</span></p>
                            <p style="text-align:center;"><span style="font-size: 24px;">на {Name}, Община {Municipality}</span></p>`,
              textHeightMM: 3
            },
            date: {
              resizibleHeight: 81,
              resizibleWidth: 246,
              resizibleLeft: 37.99999999999999,
              resizibleTop: 1501.9999999999998,
              type: 'text',
              text: '<p>{date}</p>',
              textHeightMM: 3
            },
            madeBy: {
              resizibleHeight: 81,
              resizibleWidth: 285,
              resizibleLeft: 754.6666666666665,
              resizibleTop: 1496.333333333333,
              type: 'text',
              text: `<p style="text-align:right;">Изработил: {username}</p>
                            <p style="text-align:right;">/_________________________/</p>`,
              textHeightMM: 3
            }
          },
          mapProps: {
            resizibleHeight: 1000,
            resizibleWidth: 1000,
            resizibleLeft: 50,
            resizibleTop: 200
          },
          margins: [36, 36, 36, 36],
          zoomFactor: 0.9
        },
        portrait: {
          elements: {
            scale: {
              resizibleHeight: 64,
              resizibleWidth: 311,
              resizibleLeft: 377,
              resizibleTop: 119,
              type: 'scale',
              hide: false
            },
            legend: {
              resizibleHeight: 469,
              resizibleWidth: 990,
              resizibleLeft: 52,
              resizibleTop: 1110,
              type: 'legend',
              hide: true
            },
            header: {
              resizibleHeight: 118,
              resizibleWidth: 384,
              resizibleLeft: 346.66666666666663,
              resizibleTop: 31.999999999999986,
              type: 'text',
              text: `<p style="text-align:center;"><span style="font-size: 24px;">КОПИЕ СКИЦА - ИЗВАДКА</span></p>
                            <p style="text-align:center;"><span style="font-size: 24px;">от ......................</span></p>
                            <p style="text-align:center;"><span style="font-size: 24px;">на {Name}, Община {Municipality}</span></p>`,
              textHeightMM: 3
            },
            date: {
              resizibleHeight: 81,
              resizibleWidth: 246,
              resizibleLeft: 37.99999999999999,
              resizibleTop: 1501.9999999999998,
              type: 'text',
              text: '<p>{date}</p>',
              textHeightMM: 3
            },
            madeBy: {
              resizibleHeight: 81,
              resizibleWidth: 285,
              resizibleLeft: 754.6666666666665,
              resizibleTop: 1496.333333333333,
              type: 'text',
              text: `<p style="text-align:right;">Изработил: {username}</p>
                            <p style="text-align:right;">/_________________________/</p>`,
              textHeightMM: 3
            }
          },
          mapProps: {
            resizibleHeight: 1200,
            resizibleWidth: 1000,
            resizibleLeft: 50,
            resizibleTop: 200
          },
          margins: [36, 36, 36, 36],
          zoomFactor: 0.9
        }
      },
      A3: {
        landscape: {
          elements: {
            scale: {
              resizibleHeight: 64,
              resizibleWidth: 311,
              resizibleLeft: 377,
              resizibleTop: 119,
              type: 'scale',
              hide: false
            },
            legend: {
              resizibleHeight: 469,
              resizibleWidth: 990,
              resizibleLeft: 52,
              resizibleTop: 1110,
              type: 'legend',
              hide: true
            },
            header: {
              resizibleHeight: 118,
              resizibleWidth: 384,
              resizibleLeft: 346.66666666666663,
              resizibleTop: 31.999999999999986,
              type: 'text',
              text: `<p style="text-align:center;"><span style="font-size: 24px;">КОПИЕ СКИЦА - ИЗВАДКА</span></p>
                            <p style="text-align:center;"><span style="font-size: 24px;">от ......................</span></p>
                            <p style="text-align:center;"><span style="font-size: 24px;">на {Name}, Община {Municipality}</span></p>`,
              textHeightMM: 3
            },
            date: {
              resizibleHeight: 81,
              resizibleWidth: 246,
              resizibleLeft: 37.99999999999999,
              resizibleTop: 1501.9999999999998,
              type: 'text',
              text: '<p>{date}</p>',
              textHeightMM: 3
            },
            madeBy: {
              resizibleHeight: 81,
              resizibleWidth: 285,
              resizibleLeft: 754.6666666666665,
              resizibleTop: 1496.333333333333,
              type: 'text',
              text: `<p style="text-align:right;">Изработил: {username}</p>
                            <p style="text-align:right;">/_________________________/</p>`,
              textHeightMM: 3
            }
          },
          mapProps: {
            resizibleHeight: 1000,
            resizibleWidth: 1000,
            resizibleLeft: 50,
            resizibleTop: 200
          },
          margins: [36, 36, 36, 36],
          zoomFactor: 0.9
        },
        portrait: {
          elements: {
            scale: {
              resizibleHeight: 64,
              resizibleWidth: 311,
              resizibleLeft: 377,
              resizibleTop: 119,
              type: 'scale',
              hide: false
            },
            legend: {
              resizibleHeight: 469,
              resizibleWidth: 990,
              resizibleLeft: 52,
              resizibleTop: 1110,
              type: 'legend',
              hide: true
            },
            header: {
              resizibleHeight: 118,
              resizibleWidth: 384,
              resizibleLeft: 346.66666666666663,
              resizibleTop: 31.999999999999986,
              type: 'text',
              text: `<p style="text-align:center;"><span style="font-size: 24px;">КОПИЕ СКИЦА - ИЗВАДКА</span></p>
                            <p style="text-align:center;"><span style="font-size: 24px;">от ......................</span></p>
                            <p style="text-align:center;"><span style="font-size: 24px;">на {Name}, Община {Municipality}</span></p>`,
              textHeightMM: 3
            },
            date: {
              resizibleHeight: 81,
              resizibleWidth: 246,
              resizibleLeft: 37.99999999999999,
              resizibleTop: 1501.9999999999998,
              type: 'text',
              text: '<p>{date}</p>',
              textHeightMM: 3
            },
            madeBy: {
              resizibleHeight: 81,
              resizibleWidth: 285,
              resizibleLeft: 754.6666666666665,
              resizibleTop: 1496.333333333333,
              type: 'text',
              text: `<p style="text-align:right;">Изработил: {username}</p>
                            <p style="text-align:right;">/_________________________/</p>`,
              textHeightMM: 3
            }
          },
          mapProps: {
            resizibleHeight: 1200,
            resizibleWidth: 1000,
            resizibleLeft: 50,
            resizibleTop: 200
          },
          margins: [36, 36, 36, 36],
          zoomFactor: 0.9
        }
      }
    }
    return this.mergeCustomLayouts(content)
  }

  getVisaLayouts(): IExportLayouts {
    return {
      A4: {
        portrait: {
          elements: {
            legend: {
              resizibleHeight: 469,
              resizibleWidth: 990,
              resizibleLeft: 52,
              resizibleTop: 1110,
              type: 'legend',
              hide: true
            },
            scale: {
              resizibleHeight: 38,
              resizibleWidth: 197,
              resizibleLeft: 460,
              resizibleTop: 1396,
              type: 'scale'
            },
            munInfo: {
              resizibleHeight: 147,
              resizibleWidth: 371,
              resizibleLeft: 110.99999999999999,
              resizibleTop: 65.99999999999999,
              type: 'text',
              text: '<p>Община {Municipality}</p>\n<p>Дирекция "Устройство на територията"</p>\n<p>Отдел "Устройствено планиране"</p>\n<p>№</p>',
              textHeightMM: 3
            },
            parcelInfo: {
              resizibleHeight: 162,
              resizibleWidth: 348,
              resizibleLeft: 630,
              resizibleTop: 60,
              type: 'text',
              text: `<p>ВИЗА ЗА ПРОЕКТИРАНЕ </p>\n
                <p></p>\n
                <p>УПИ {ParcelNumber} <sub>{CadNumbers}</sub> , кв {QuarterNumber}  с площ {Area} кв. м</p>\n
                <p>от действащ ПУП-ПРЗ на {SettlementName} </p>\n
                <p>одобрен със Заповед № {PlanName} / {PlanDate}</p>\n
                <p style="text-align:left;">на {PlanApprover} </p>\n`,
              textHeightMM: 3
            },
            '73ede9d0-9ece-4b04-b1a9-f84ed7348a2c': {
              resizibleHeight: 118,
              resizibleWidth: 286,
              resizibleLeft: 775.9999999999999,
              resizibleTop: 1486.7600097656248,
              type: 'text',
              text: '<p style="text-align:left;">Главен Архитект .............................</p>',
              textHeightMM: 3
            },
            neighboursField: {
              resizibleHeight: 300,
              resizibleWidth: 990,
              resizibleLeft: 100,
              resizibleTop: 1000,
              type: 'text',
              text: `<p>Имота е записан на </p>
              <p><b>{Owner}<p></p>\n
              <p></p>\n<p></p>\n
              <p>На основание на .........................</p>
              </b></p><p>Съседи</p>\n{AdditionalData}`,
              textHeightMM: 3
            },
            date: {
              resizibleHeight: 81,
              resizibleWidth: 246,
              resizibleLeft: 37.99999999999999,
              resizibleTop: 1501.9999999999998,
              type: 'text',
              text: '<p>{date}</p>',
              textHeightMM: 3
            }
          },
          mapProps: {
            resizibleHeight: 700,
            resizibleWidth: 935,
            resizibleLeft: 104,
            resizibleTop: 235
          },
          margins: [36, 36, 36, 36],
          zoomFactor: 0.5
        },
        landscape: {
          elements: {
            scale: {
              resizibleHeight: 64,
              resizibleWidth: 311,
              resizibleLeft: 1200,
              resizibleTop: 400,
              type: 'scale',
              hide: false
            },
            legend: {
              resizibleHeight: 469,
              resizibleWidth: 990,
              resizibleLeft: 52,
              resizibleTop: 1110,
              type: 'legend',
              hide: true
            },
            munInfo: {
              resizibleHeight: 147,
              resizibleWidth: 371,
              resizibleLeft: 850,
              resizibleTop: 50,
              type: 'text',
              text: '<p>Община {Municipality}</p>\n<p>Дирекция "Устройство на територията"</p>\n<p>Отдел "Устройствено планиране"</p>\n<p>№</p>',
              textHeightMM: 3
            },
            header: {
              resizibleHeight: 162,
              resizibleWidth: 348,
              resizibleLeft: 1250,
              resizibleTop: 50,
              type: 'text',
              text: `<p>ВИЗА ЗА ПРОЕКТИРАНЕ </p>\n
              <p></p>\n
              <p>УПИ {ParcelNumber} <sub>{CadNumbers}</sub> , кв {QuarterNumber}  с площ {Area} кв. м</p>\n
              <p>от действащ ПУП-ПРЗ на {SettlementName} </p>\n
              <p>одобрен със Заповед № {PlanName} / {PlanDate}</p>\n
              <p style="text-align:left;">на {PlanApprover} </p>\n`,
              textHeightMM: 3
            },
            date: {
              resizibleHeight: 81,
              resizibleWidth: 246,
              resizibleLeft: 900,
              resizibleTop: 1050,
              type: 'text',
              text: '<p>{date}</p>',
              textHeightMM: 3
            },
            'd45bc41f-39dd-4e36-b9bc-0e38a7d6666d': {
              resizibleHeight: 126,
              resizibleWidth: 278,
              resizibleLeft: 1300,
              resizibleTop: 880,
              type: 'text',
              text: '<p style="text-align:left;">Заверил:</p>\n<p style="text-align:left;">Началник "УП".................................</p>\n<p style="text-align:right;">.......</p>\n',
              textHeightMM: 3
            },
            '73ede9d0-9ece-4b04-b1a9-f84ed7348a2c': {
              resizibleHeight: 118,
              resizibleWidth: 286,
              resizibleLeft: 1300,
              resizibleTop: 980,
              type: 'text',
              text: '<p style="text-align:left;">Изчертал:</p>\n<p style="text-align:left;">Гл. експерт "УП".............................</p>\n<p style="text-align:right;">.......</p>\n',
              textHeightMM: 3
            },
            neighboursField: {
              resizibleHeight: 300,
              resizibleWidth: 990,
              resizibleLeft: 900,
              resizibleTop: 500,
              type: 'text',
              text: `<p>Имота е записан на </p>
              <p><b>{Owner}<p></p>\n
              <p></p>\n<p></p>\n
              <p>На основание на .........................</p>
              </b></p><p>Съседи</p>\n{AdditionalData}`,
              textHeightMM: 3
            }
          },
          mapProps: {
            resizibleHeight: 990,
            resizibleWidth: 750,
            resizibleLeft: 50,
            resizibleTop: 50
          },
          margins: [36, 36, 36, 36],
          zoomFactor: 0.5
        }
      }
    }
  }
  getUpiOUPLayouts(): IExportLayouts {
    return {
      A4: {
        portrait: {
          elements: {
            legend: {
              resizibleHeight: 469,
              resizibleWidth: 990,
              resizibleLeft: 52,
              resizibleTop: 1110,
              type: 'legend',
              hide: true
            },
            scale: {
              resizibleHeight: 38,
              resizibleWidth: 197,
              resizibleLeft: 460,
              resizibleTop: 1501,
              type: 'scale'
            },
            munInfo: {
              resizibleHeight: 147,
              resizibleWidth: 371,
              resizibleLeft: 110.99999999999999,
              resizibleTop: 65.99999999999999,
              type: 'text',
              text: '<p>Община {Municipality}</p>\n<p>Дирекция "Устройство на територията"</p>\n<p>Отдел "Устройствено планиране"</p>\n<p>№</p>',
              textHeightMM: 3
            },
            parcelInfo: {
              resizibleHeight: 162,
              resizibleWidth: 348,
              resizibleLeft: 630,
              resizibleTop: 60,
              type: 'text',
              text: `<p>Извадка за УПИ от ОУП </p>\n
                <p></p>\n
                <p>УПИ {ParcelNumber} <sub>{CadNumbers}</sub> , кв {QuarterNumber}  с площ {Area} кв. м</p>\n
                <p>от действащ ПУП-ПРЗ на {SettlementName} </p>\n
                <p>одобрен със Заповед № {PlanName} / {PlanDate}</p>\n
                <p style="text-align:left;">на {PlanApprover} </p>\n`,
              textHeightMM: 3
            },
            neighboursField: {
              resizibleHeight: 600,
              resizibleWidth: 990,
              resizibleLeft: 100,
              resizibleTop: 750,
              type: 'text',
              text: `{AdditionalData}`,
              textHeightMM: 3
            },
            date: {
              resizibleHeight: 81,
              resizibleWidth: 246,
              resizibleLeft: 37.99999999999999,
              resizibleTop: 1501.9999999999998,
              type: 'text',
              text: '<p>{date}</p>',
              textHeightMM: 3
            }
          },
          mapProps: {
            resizibleHeight: 500,
            resizibleWidth: 935,
            resizibleLeft: 104,
            resizibleTop: 235
          },
          margins: [36, 36, 36, 36],
          zoomFactor: 0.5
        },
        landscape: {
          elements: {
            scale: {
              resizibleHeight: 64,
              resizibleWidth: 311,
              resizibleLeft: 1200,
              resizibleTop: 400,
              type: 'scale',
              hide: false
            },
            legend: {
              resizibleHeight: 469,
              resizibleWidth: 990,
              resizibleLeft: 52,
              resizibleTop: 1110,
              type: 'legend',
              hide: true
            },
            munInfo: {
              resizibleHeight: 147,
              resizibleWidth: 371,
              resizibleLeft: 850,
              resizibleTop: 50,
              type: 'text',
              text: '<p>Община {Municipality}</p>\n<p>Дирекция "Устройство на територията"</p>\n<p>Отдел "Устройствено планиране"</p>\n<p>№</p>',
              textHeightMM: 3
            },
            header: {
              resizibleHeight: 162,
              resizibleWidth: 348,
              resizibleLeft: 1250,
              resizibleTop: 50,
              type: 'text',
              text: `<p>Извадка за УПИ от ОУП </p>\n
              <p></p>\n
              <p>УПИ {ParcelNumber} <sub>{CadNumbers}</sub> , кв {QuarterNumber}  с площ {Area} кв. м</p>\n
              <p>от действащ ПУП-ПРЗ на {SettlementName} </p>\n
              <p>одобрен със Заповед № {PlanName} / {PlanDate}</p>\n
              <p style="text-align:left;">на {PlanApprover} </p>\n`,
              textHeightMM: 3
            },
            date: {
              resizibleHeight: 81,
              resizibleWidth: 246,
              resizibleLeft: 900,
              resizibleTop: 1050,
              type: 'text',
              text: '<p>{date}</p>',
              textHeightMM: 3
            },
            'd45bc41f-39dd-4e36-b9bc-0e38a7d6666d': {
              resizibleHeight: 126,
              resizibleWidth: 278,
              resizibleLeft: 1300,
              resizibleTop: 880,
              type: 'text',
              text: '<p style="text-align:left;">Заверил:</p>\n<p style="text-align:left;">Началник "УП".................................</p>\n<p style="text-align:right;">.......</p>\n',
              textHeightMM: 3
            },
            '73ede9d0-9ece-4b04-b1a9-f84ed7348a2c': {
              resizibleHeight: 118,
              resizibleWidth: 286,
              resizibleLeft: 1300,
              resizibleTop: 980,
              type: 'text',
              text: '<p style="text-align:left;">Изчертал:</p>\n<p style="text-align:left;">Гл. експерт "УП".............................</p>\n<p style="text-align:right;">.......</p>\n',
              textHeightMM: 3
            },
            neighboursField: {
              resizibleHeight: 300,
              resizibleWidth: 990,
              resizibleLeft: 900,
              resizibleTop: 500,
              type: 'text',
              text: `{AdditionalData}`,
              textHeightMM: 3
            }
          },
          mapProps: {
            resizibleHeight: 990,
            resizibleWidth: 750,
            resizibleLeft: 50,
            resizibleTop: 50
          },
          margins: [36, 36, 36, 36],
          zoomFactor: 0.5
        }
      }
    }
  }

  mergeCustomLayouts(content: IExportLayouts): IExportLayouts {
    const customExportsString = localStorage.getItem(this.state.selectedExport)
    if (customExportsString) {
      const customExports = JSON.parse(decodeURIComponent(atob(customExportsString))) as IExportLayouts
      const merged = merge({}, content, customExports)
      return merged
    }
    return content
  }

  getCustomLayouts(): IExportLayouts {
    const content: IExportLayouts = {
      A4: {
        portrait: {
          elements: {
            legend: {
              resizibleHeight: 469,
              resizibleWidth: 990,
              resizibleLeft: 52,
              resizibleTop: 1110,
              type: 'legend',
              hide: true
            },
            scale: {
              resizibleHeight: 38,
              resizibleWidth: 197,
              resizibleLeft: 460,
              resizibleTop: 1396,
              type: 'scale'
            }
          },
          mapProps: {
            resizibleHeight: 700,
            resizibleWidth: 935,
            resizibleLeft: 104,
            resizibleTop: 235
          },
          margins: [36, 36, 36, 36],
          zoomFactor: 0.5
        },
        landscape: {
          elements: {
            scale: {
              resizibleHeight: 64,
              resizibleWidth: 311,
              resizibleLeft: 1200,
              resizibleTop: 400,
              type: 'scale',
              hide: false
            }
          },
          mapProps: {
            resizibleHeight: 990,
            resizibleWidth: 750,
            resizibleLeft: 50,
            resizibleTop: 50
          },
          margins: [36, 36, 36, 36],
          zoomFactor: 0.5
        }
      },
      A3: {
        portrait: {
          elements: {
            legend: {
              resizibleHeight: 469,
              resizibleWidth: 990,
              resizibleLeft: 52,
              resizibleTop: 1110,
              type: 'legend',
              hide: true
            },
            scale: {
              resizibleHeight: 38,
              resizibleWidth: 197,
              resizibleLeft: 460,
              resizibleTop: 1396,
              type: 'scale'
            }
          },
          mapProps: {
            resizibleHeight: 700,
            resizibleWidth: 935,
            resizibleLeft: 104,
            resizibleTop: 235
          },
          margins: [36, 36, 36, 36],
          zoomFactor: 0.5
        },
        landscape: {
          elements: {
            scale: {
              resizibleHeight: 64,
              resizibleWidth: 311,
              resizibleLeft: 1200,
              resizibleTop: 400,
              type: 'scale',
              hide: false
            }
          },
          mapProps: {
            resizibleHeight: 990,
            resizibleWidth: 750,
            resizibleLeft: 50,
            resizibleTop: 50
          },
          margins: [36, 36, 36, 36],
          zoomFactor: 0.5
        }
      }
    }
    return this.mergeCustomLayouts(content)
  }

  get1Layouts(): IExportLayouts {
    const content: IExportLayouts = {
      A4: {
        portrait: {
          elements: {
            legend: {
              resizibleHeight: 469,
              resizibleWidth: 990,
              resizibleLeft: 52,
              resizibleTop: 1110,
              type: 'legend',
              hide: true
            },
            scale: {
              resizibleHeight: 38,
              resizibleWidth: 197,
              resizibleLeft: 460,
              resizibleTop: 1396,
              type: 'scale'
            },
            munInfo: {
              resizibleHeight: 147,
              resizibleWidth: 371,
              resizibleLeft: 110.99999999999999,
              resizibleTop: 65.99999999999999,
              type: 'text',
              text: '<p>Община {Municipality}</p>\n<p>Дирекция "Устройство на територията"</p>\n<p>Отдел "Устройствено планиране"</p>\n<p>№</p>',
              textHeightMM: 3
            },
            parcelInfo: {
              resizibleHeight: 162,
              resizibleWidth: 348,
              resizibleLeft: 630,
              resizibleTop: 60,
              type: 'text',
              text: `<p>СКИЦА - ИЗВАДКА</p>\n<p></p>\n<p>УПИ {ParcelNumber}<sub>{CadNumbers}</sub>,
              кв {QuarterNumber} с площ {Area}кв. м</p>\n<p>от действащ ПУП-ПРЗ </p>\n<p>на
              {SettlementName}</p>\n<p>одобрен със Заповед № {PlanName} / {PlanDate}
              </p>\n<p style="text-align:left;">на {PlanApprover}</p>\n`,
              textHeightMM: 3
            },
            'd45bc41f-39dd-4e36-b9bc-0e38a7d6666d': {
              resizibleHeight: 126,
              resizibleWidth: 278,
              resizibleLeft: 774.9999999999999,
              resizibleTop: 1396.7600097656248,
              type: 'text',
              text: '<p style="text-align:left;">Заверил:</p>\n<p style="text-align:left;">Началник "УП".................................</p>\n<p style="text-align:right;">.......</p>\n',
              textHeightMM: 3
            },
            '73ede9d0-9ece-4b04-b1a9-f84ed7348a2c': {
              resizibleHeight: 118,
              resizibleWidth: 286,
              resizibleLeft: 775.9999999999999,
              resizibleTop: 1486.7600097656248,
              type: 'text',
              text: '<p style="text-align:left;">Изчертал:</p>\n<p style="text-align:left;">Гл. експерт "УП".............................</p>\n<p style="text-align:right;">.......</p>\n',
              textHeightMM: 3
            },
            neighboursField: {
              resizibleHeight: 300,
              resizibleWidth: 990,
              resizibleLeft: 100,
              resizibleTop: 1000,
              type: 'text',
              text: `<p>Имота е записан на </p>
              <p><b>{Owner}<p></p>\n
              <p></p>\n<p></p>\n
              <p>На основание на .........................</p>
              </b></p><p>Съседи</p>\n{AdditionalData}`,
              textHeightMM: 3
            },
            date: {
              resizibleHeight: 81,
              resizibleWidth: 246,
              resizibleLeft: 37.99999999999999,
              resizibleTop: 1501.9999999999998,
              type: 'text',
              text: '<p>{date}</p>',
              textHeightMM: 3
            }
          },
          mapProps: {
            resizibleHeight: 700,
            resizibleWidth: 935,
            resizibleLeft: 104,
            resizibleTop: 235
          },
          margins: [36, 36, 36, 36],
          zoomFactor: 0.5
        },
        landscape: {
          elements: {
            scale: {
              resizibleHeight: 64,
              resizibleWidth: 311,
              resizibleLeft: 1200,
              resizibleTop: 400,
              type: 'scale',
              hide: false
            },
            legend: {
              resizibleHeight: 469,
              resizibleWidth: 990,
              resizibleLeft: 52,
              resizibleTop: 1110,
              type: 'legend',
              hide: true
            },
            munInfo: {
              resizibleHeight: 147,
              resizibleWidth: 371,
              resizibleLeft: 850,
              resizibleTop: 50,
              type: 'text',
              text: '<p>Община {Municipality}</p>\n<p>Дирекция "Устройство на територията"</p>\n<p>Отдел "Устройствено планиране"</p>\n<p>№</p>',
              textHeightMM: 3
            },
            header: {
              resizibleHeight: 162,
              resizibleWidth: 348,
              resizibleLeft: 1250,
              resizibleTop: 50,
              type: 'text',
              text: `<p>СКИЦА - ИЗВАДКА</p>\n<p></p>\n<p>УПИ {ParcelNumber}<sub>{CadNumbers}</sub>,
                кв {QuarterNumber} с площ {Area}кв. м</p>\n<p>от действащ ПУП-ПРЗ </p>\n<p>на
                {SettlementName}</p>\n<p>одобрен със Заповед № {PlanName} / {PlanDate}
                </p>\n<p style="text-align:left;">на {PlanApprover}</p>\n`,
              textHeightMM: 3
            },
            date: {
              resizibleHeight: 81,
              resizibleWidth: 246,
              resizibleLeft: 900,
              resizibleTop: 1050,
              type: 'text',
              text: '<p>{date}</p>',
              textHeightMM: 3
            },
            'd45bc41f-39dd-4e36-b9bc-0e38a7d6666d': {
              resizibleHeight: 126,
              resizibleWidth: 278,
              resizibleLeft: 1300,
              resizibleTop: 880,
              type: 'text',
              text: '<p style="text-align:left;">Заверил:</p>\n<p style="text-align:left;">Началник "УП".................................</p>\n<p style="text-align:right;">.......</p>\n',
              textHeightMM: 3
            },
            '73ede9d0-9ece-4b04-b1a9-f84ed7348a2c': {
              resizibleHeight: 118,
              resizibleWidth: 286,
              resizibleLeft: 1300,
              resizibleTop: 980,
              type: 'text',
              text: '<p style="text-align:left;">Изчертал:</p>\n<p style="text-align:left;">Гл. експерт "УП".............................</p>\n<p style="text-align:right;">.......</p>\n',
              textHeightMM: 3
            },
            neighboursField: {
              resizibleHeight: 300,
              resizibleWidth: 990,
              resizibleLeft: 900,
              resizibleTop: 500,
              type: 'text',
              text: `<p>Имота е записан на </p>
              <p><b>{Owner}<p></p>\n
              <p></p>\n<p></p>\n
              <p>На основание на .........................</p>
              </b></p><p>Съседи</p>\n{AdditionalData}`,
              textHeightMM: 3
            }
          },
          mapProps: {
            resizibleHeight: 990,
            resizibleWidth: 750,
            resizibleLeft: 50,
            resizibleTop: 50
          },
          margins: [36, 36, 36, 36],
          zoomFactor: 0.5
        }
      }
    }
    return this.mergeCustomLayouts(content)
  }
  getDay() {
    const day = new Date().getDate()
    return day
  }
  getMounthNumber() {
    const mount = new Date().getMonth() + 1
    return mount
  }

  getMounth() {
    const mount = new Date().getMonth() + 1
    switch (mount) {
      case 1:
        return 'Януари'
      case 2:
        return 'Февруари'
      case 3:
        return 'Март'
      case 4:
        return 'Април'
      case 5:
        return 'Май'
      case 6:
        return 'Юни'
      case 7:
        return 'Юли'
      case 8:
        return 'Август'
      case 9:
        return 'Септември'
      case 10:
        return 'Октомври'
      case 11:
        return 'Ноември'
      default:
        return 'Декември'
    }
  }

  clearpointsource() {
    const mapService = getMapService()
    if (mapService) {
      mapService.getLayers().forEach(l => {
        if (l.moreInfo.urls.indexOf(appConfig.reg.traspoints.url) != -1) {
          ;(l as VectorLayer).getSource().clear()
        }
      })
    }
  }

  protected GetPointLayyer(): VectorLayer | undefined {
    let coordpointsLayer: VectorLayer | undefined = undefined
    const mapService = getMapService()
    if (mapService) {
      mapService.getLayers().forEach(l => {
        if (l.moreInfo.urls.indexOf(appConfig.reg.traspoints.url) != -1) {
          coordpointsLayer = l as VectorLayer
        }
      })
    }
    return coordpointsLayer
  }

  protected setUpiPoints(selectedParcel: Feature): Feature[] {
    const coords = selectedParcel.getGeometry().getCoordinates() as number[][][]
    const bgcoords = selectedParcel.get('BgGeom').getCoordinates() as number[][][]

    const coordpointsLayer = this.GetPointLayyer()
    const feats: Feature[] = []
    if (this.state.selectedExport == 'upicoordinates') {
      if (coordpointsLayer) {
        coords.forEach((ring, j) => {
          ring.forEach((point, i) => {
            const feat = new Feature()
            feat.set('Id', uuidv4())
            feat.set('Number', i + 1)
            feat.set('Coord70', bgcoords[j][i])
            feat.set('Visible', '1')
            feat.set('Rotation', 0)
            feat.setGeometry(new Point([point[0], point[1]] as any))
            feats.push(feat)
            coordpointsLayer!.getSource().addFeature(feat as any)
          })
        })
      }
    }
    return feats
  }

  protected UpdateUpiPoint(points: Feature[]) {
    this.setState({...this.state, trasCoordinates: points}, () => {
      const coordpointsLayer = this.GetPointLayyer()
      if (coordpointsLayer) {
        coordpointsLayer!.getSource().clear()
        points.forEach(p => {
          coordpointsLayer!.getSource().addFeature(p as any)
        })
      }
      for (const format in this.props.exportMapStore.layouts) {
        const twoFormats = this.props.exportMapStore.layouts[format]
        const portrait = twoFormats.portrait
        const landscape = twoFormats.landscape
        if (portrait.elements['coordinates']) {
          portrait.zoomFactor = this.props.exportMapStore.zoomFactor
          portrait.elements['coordinates'].text = this.getTrasPointsLayoutText()
        }
        if (landscape.elements['coordinates']) {
          landscape.zoomFactor = this.props.exportMapStore.zoomFactor
          landscape.elements['coordinates'].text = this.getTrasPointsLayoutText()
        }
      }
      this.props.setLayouts(true, this.props.exportMapStore.layouts)
    })

    //TODO UPTATE LAYOUT
  }

  getTrasPointsLayoutText(): string {
    let coordinatesString = '<tr><th>№</th><th>Y [m]</th><th>X [m]</th></tr>'
    this.state.trasCoordinates.forEach((point, i) => {
      const coord = point.get('Coord70')
      coordinatesString += `<tr><td>${point.get('Number')}</td><td>${coord[0].toFixed(2)}</td><td>${coord[1].toFixed(
        2
      )}</td></tr>`
    })
    coordinatesString = `<p style=\"text-align:left;\">Координатна система</p> БГС 2005 Кадастрална:</p>\n<table><tbody>${coordinatesString}</tbody></table>`
    return coordinatesString
  }

  getFormattedDate(datestring: string) {
    const temp = datestring.split('T')[0].split('-')
    const newdate = temp[2] + '.' + temp[1] + '.' + temp[0] + 'г.'
    return newdate
  }

  async getNeighbours(parcelId: string) {
    const config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: process.env.HOST_API_URL + '/GetNeighbours?id=' + parcelId,
      headers: {}
    }
    try {
      const res = await Axios.request(config)
      return res.data
    } catch (err) {
      console.error(err)
    }
  }

  async GetUpiOUPParams(parcelId: string) {
    const config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: process.env.HOST_API_URL + '/GetUpiOUPParams?id=' + parcelId,
      headers: {}
    }
    try {
      const res = await Axios.request(config)
      return res.data
    } catch (err) {
      console.error(err)
    }
  }

  setExportType(selectedExport: selectTYpes) {
    this.setState({...this.state, selectedExport: selectedExport}, () => {
      if (
        (selectedExport == 'upicoordinates' ||
          selectedExport == 'izvadka2' ||
          selectedExport == 'visa' ||
          selectedExport == 'upi-oup') &&
        !this.state.selectedParcel
      ) {
        this.activateUpiIdentDraw()
      } else {
        getMapService().drawing.deactivateDraw(true)
      }

      if (selectedExport == 'izvadka') {
        if (this.state.selectedSet) {
          const layouts = {...this.getIzvadkaLayouts()}
          this.props.setLayouts(false, layouts, this.state.selectedSet)
          setTimeout(() => {
            this.props.setPageSize(PageSize.A4, false)
          }, 100)
        }
      }
      if (selectedExport == 'prn_izvadka') {
        if (this.state.selectedSet) {
          const layouts = {...this.getPrnIzvadka()}
          this.props.setLayouts(false, layouts, this.state.selectedSet)
          setTimeout(() => {
            this.props.setPageSize(PageSize.A3, false)
          }, 100)
        }
      }
      if (selectedExport == 'combined') {
        if (this.state.selectedSet) {
          const layouts = {...this.getCombinedPlan()}
          this.props.setLayouts(false, layouts, this.state.selectedSet)
          setTimeout(() => {
            this.props.setPageSize(PageSize.A4, false)
          }, 100)
        }
      } else if (selectedExport == 'izvadka2') {
        if (this.state.selectedParcel) {
          this.getNeighbours(this.state.selectedParcel.getId()).then(neighbours => {
            const data: any = {}
            let str =
              '<table><tbody><tr><th witdth=50>&nbsp;&nbsp;№&nbsp;&nbsp;&nbsp;</th><th witdth=50>&nbsp;&nbsp;&nbsp;УПИ&nbsp;&nbsp;&nbsp;</th><th>&nbsp;&nbsp;&nbsp;Собственик&nbsp;&nbsp;&nbsp;</th></tr>'
            let count = 1
            neighbours['neighbours'].forEach((neighbour: any) => {
              const n = neighbour.Owner ? neighbour.Owner : 'Няма данни'
              str +=
                '<tr><td witdth=50>' +
                count +
                '</td><td witdth=50>УПИ ' +
                neighbour.ParcelNumber +
                '<sub>' +
                neighbour.CadNumbers +
                '</sub></td><td>&nbsp;&nbsp;&nbsp;' +
                n +
                '</td></tr>'
              count++
            })
            neighbours['streets'].forEach(() => {
              str += '<tr><td witdth=50>' + count + '</td><td witdth=50>Улица </td><td></td></tr>'
              count++
            })
            str += '</tbody></table>'
            data['parcel'] = this.state.selectedParcel
            data['neighbours'] = str
            const layouts = {...this.get1Layouts()}
            this.props.setLayouts(false, layouts, this.state.selectedParcel, data['neighbours'])
            setTimeout(() => {
              this.props.setPageSize(PageSize.A4, false)
            }, 100)
          })
        }
      } else if (selectedExport == 'upicoordinates') {
        const layouts = {...this.getUpiCoordsIzvadka()}
        this.props.setLayouts(false, layouts, this.state.selectedParcel, this.getTrasPointsLayoutText())
        setTimeout(() => {
          this.props.setPageSize(PageSize.A4, false)
        }, 100)
      } else if (selectedExport == 'visa') {
        if (this.state.selectedParcel) {
          const data: any = {}
          data['parcel'] = this.state.selectedParcel
          const layouts = {...this.getVisaLayouts()}
          this.props.setLayouts(false, layouts, this.state.selectedParcel)
          setTimeout(() => {
            this.props.setPageSize(PageSize.A4, false)
          }, 100)
        }
      } else if (selectedExport == 'upi-oup') {
        if (this.state.selectedParcel) {
          const mapping: {[key: string]: string} = {
            developmentzone_decs: 'Тип зона',
            floor: 'Eтажност',
            height: 'Височина',
            buildingdensity: 'Плътност',
            minbuildingdensity: 'Минимална плътност',
            maxbuildingdensity: 'Максимална плътност',
            kint: 'Кинт',
            minkint: 'Минимален кинт',
            maxkint: 'Максимален кинт',
            maxmingreenarea: 'Максимална зелена площ',
            mingreenarea: 'Минимална зелена площ',
            numberzone: 'Номер на зона',
            desc: 'Описание',
            mingreenarea_desc: 'Описание зелена площ'
          }
          let str = ''

          this.GetUpiOUPParams(this.state.selectedParcel.getId()).then(oupdata => {
            for (const line in oupdata) {
              for (const key in mapping) {
                if (oupdata[line][key]) {
                  str += '<b>' + mapping[key] + '</b>\t\t\t' + oupdata[line][key] + '<br />\n'
                }
              }
              str += '<br />\n'
            }
            const layouts = {...this.getUpiOUPLayouts()}
            this.props.setLayouts(false, layouts, this.state.selectedParcel, str)
            setTimeout(() => {
              this.props.setPageSize(PageSize.A4, false)
            }, 100)
          })
        }
      } else if (selectedExport == 'custom') {
        const layouts = {...this.getCustomLayouts()}
        this.props.setLayouts(false, layouts)
        setTimeout(() => {
          this.props.setPageSize(PageSize.A4, false)
        }, 100)
      } else if (selectedExport == 'regular') {
        this.props.setLayouts(false, appConfig.layouts)
        setTimeout(() => {
          this.props.setPageSize(PageSize.A4, false)
          setTimeout(() => {
            this.setState({...this.state, selectedExport: selectedExport})
          }, 100)
        }, 100)
      }
    })
  }

  getSelector() {
    return (
      <div
        style={{
          padding: '15px',
          boxSizing: 'border-box',
          height: '70px'
        }}
      >
        <select
          className="form-control"
          value={this.state.selectedExport}
          onChange={e => {
            const coordpointsLayer = this.GetPointLayyer()
            if (coordpointsLayer) {
              coordpointsLayer!.getSource().clear()
            }
            this.setExportType(e.target.value as selectTYpes)
          }}
        >
          <option value={'izvadka'}>КОПИЕ СКИЦА - ИЗВАДКА</option>
          <option value={'izvadka2'}>КОПИЕ СКИЦА - ИЗВАДКА НА ПАРЦЕЛ</option>
          <option value={'regular'}>Обикновен експорт</option>
          <option value={'prn_izvadka'}>Скица-Извадка от действащ ПНИ</option>
          <option value={'combined'}>Комбинирана скица</option>
          <option value={'upicoordinates'}>Координати на УПИ</option>
          <option value={'visa'}>Виза</option>
          <option value={'upi-oup'}>Извадка на УПИ от ОУП</option>
          <option value={'custom'}>Персонализирана скица (в разработка)</option>
        </select>
      </div>
    )
  }

  getParametersSelector() {
    let content = <div></div>
    if (
      this.state.selectedExport == 'izvadka' ||
      this.state.selectedExport == 'prn_izvadka' ||
      this.state.selectedExport == 'combined'
    ) {
      content = (
        <LocationSelector
          hideLocations={true}
          onSettlementsChange={(locs, sett, loc) => {
            this.setState({...this.state, selectedLocation: loc, selectedSet: sett}, () => {
              this.setExportType(this.state.selectedExport)
            })
          }}
          selectedSettlemet={this.state.selectedSet}
          selectedLocation={this.state.selectedLocation}
        />
      )
    } else if (
      this.state.selectedExport == 'izvadka2' ||
      this.state.selectedExport == 'upicoordinates' ||
      this.state.selectedExport == 'visa' ||
      this.state.selectedExport == 'upi-oup'
    ) {
      content = this.state.selectedParcel ? (
        <div></div>
      ) : (
        <div className="error-div">Моля, посочете парцел на картата</div>
      )
    }
    return (
      <div
        style={{
          padding: '16px',
          marginTop: '-20px'
        }}
      >
        {content}
      </div>
    )
  }
  rotateInterval: ReturnType<typeof setInterval> | undefined = undefined
  protected CoordinateEditor() {
    const rows: JSX.Element[] = [
      <tr key={'ASD'}>
        <th style={{width: '100%'}}>Номер</th>
        <th>Инструменти</th>
      </tr>
    ]
    this.state.trasCoordinates.forEach(p => {
      rows.push(
        <tr key={p.getId()}>
          <td>{p.get('Number')}</td>
          <td>
            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-evenly'}}>
              <span
                title="Премахни"
                style={{fontSize: '16px', cursor: 'pointer'}}
                onClick={() => {
                  let feats = this.state.trasCoordinates.filter(c => c.get('Id') != p.get('Id'))
                  feats.forEach((f, i) => {
                    f.set('Number', i + 1)
                  })
                  feats = feats.sort((a, b) => (a.get('Number') - b.get('Number') > 0 ? 1 : -1))
                  this.UpdateUpiPoint(feats)
                }}
              >
                <i className="fas fa-trash" />
              </span>
              <span
                title="Завърти"
                style={{fontSize: '16px', cursor: this.state.rotating ? 'progress' : 'pointer'}}
                onMouseDown={() => {
                  if (this.rotateInterval) {
                    clearInterval(this.rotateInterval)
                  }
                  this.setState({...this.state, rotating: true})
                  this.rotateInterval = setInterval(() => {
                    p.set('Rotation', (p.get('Rotation') || 0) + 0.3)
                    this.UpdateUpiPoint([...this.state.trasCoordinates])
                  }, 100)
                }}
                onMouseUp={() => {
                  this.setState({...this.state, rotating: false})
                  if (this.rotateInterval) {
                    clearInterval(this.rotateInterval)
                  }
                }}
              >
                <i className="fas fa-redo" />
              </span>
              <span
                title="Покажи на картата"
                style={{fontSize: '16px', cursor: 'pointer'}}
                onClick={() => {
                  getMapService().panTo(p.getGeometry())
                  getMapService().drawing.flash([p.getGeometry()])
                }}
              >
                <i className="fas fa-crosshairs" />
              </span>
            </div>
          </td>
        </tr>
      )
    })
    return (
      <Collapsible
        contentId="asd"
        height={`${41 * this.state.trasCoordinates.length + 120}px`}
        mobile={false}
        open={this.state.coordinateCorrectionsOpen}
        toggleOpen={() => {
          this.setState({...this.state, coordinateCorrectionsOpen: !this.state.coordinateCorrectionsOpen})
        }}
        triggerComponent={
          <div
            style={{
              height: '40px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
              backgroundColor: '#d6dad3'
            }}
          >
            Координатен регистър
          </div>
        }
        triggerHeight="40px"
      >
        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-evenly'}}>
          <div>От точка</div>
          <input
            type="number"
            value={this.state.fromToForDelete[0]}
            onChange={e => {
              this.setState({
                ...this.state,
                fromToForDelete: [e.target.value ? parseInt(e.target.value) : 1, this.state.fromToForDelete[1]]
              })
            }}
            className="form-control"
            style={{width: '70px'}}
          ></input>
          <div>До точка</div>
          <input
            onChange={e => {
              this.setState({
                ...this.state,
                fromToForDelete: [this.state.fromToForDelete[0], e.target.value ? parseInt(e.target.value) : 1]
              })
            }}
            type="number"
            value={this.state.fromToForDelete[1]}
            className="form-control"
            style={{width: '70px'}}
          ></input>
          <button
            type="button"
            className="button"
            onClick={() => {
              let feats = this.state.trasCoordinates.filter(
                c => c.get('Number') < this.state.fromToForDelete[0] || c.get('Number') > this.state.fromToForDelete[1]
              )
              feats.forEach((f, i) => {
                f.set('Number', i + 1)
              })
              feats = feats.sort((a, b) => (a.get('Number') - b.get('Number') > 0 ? 1 : -1))
              this.UpdateUpiPoint(feats)
            }}
          >
            Изтрий
          </button>
        </div>
        <table className="table table-striped">
          <tbody>{rows}</tbody>
        </table>
      </Collapsible>
    )
  }

  getContent() {
    const expControlProps = {
      hideWithMap: false,
      hideDpi: true,
      hideScaleToggle: false,
      hideLegendToggle: false,
      hideScaleSetter: false,
      pageSizeFilter: undefined,
      selectedExport: this.state.selectedExport
    }
    if (
      this.state.selectedExport == 'izvadka' ||
      this.state.selectedExport == 'izvadka2' ||
      this.state.selectedExport == 'visa' ||
      this.state.selectedExport == 'upi-oup'
    ) {
      expControlProps.hideLegendToggle = true
      expControlProps.pageSizeFilter = ['A4', 'A3'] as any
    }
    if (this.state.selectedExport == 'custom') {
      expControlProps.pageSizeFilter = ['A4', 'A3'] as any
    }
    return (
      <div>
        {this.getParametersSelector()}
        {this.state.selectedParcel &&
        (this.state.selectedExport == 'upicoordinates' ||
          this.state.selectedExport == 'izvadka2' ||
          this.state.selectedExport == 'visa' ||
          this.state.selectedExport == 'upi-oup') ? (
          <button
            type="button"
            className="button width"
            onClick={() => {
              this.props.setFeatures([])
              this.clearpointsource()
              getMapService().drawing.unMark(DrawSource.ExportSelect)
            }}
          >
            ИЗБЕРИ НОВО УПИ
          </button>
        ) : null}
        {(this.state.selectedExport == 'izvadka' && !this.state.selectedSet) ||
        (this.state.selectedExport == 'prn_izvadka' && !this.state.selectedSet) ||
        (this.state.selectedExport == 'izvadka2' && !this.state.selectedParcel) ||
        (this.state.selectedExport == 'visa' && !this.state.selectedParcel) ||
        (this.state.selectedExport == 'upi-oup' && !this.state.selectedParcel) ||
        (this.state.selectedExport == 'upicoordinates' && !this.state.selectedParcel) ? null : (
          <AppExportMapControl {...expControlProps}></AppExportMapControl>
        )}
        {this.state.selectedExport == 'upicoordinates' && this.state.selectedParcel ? this.CoordinateEditor() : null}
      </div>
    )
  }

  render() {
    return (
      <div className="app-export-selector">
        {this.getSelector()}
        {this.getContent()}
      </div>
    )
  }
}
export const mapStateToProps = (store: IAppStore) => {
  return {
    vectorLayerImagesLoaded: store.layerInfos.vectorLayerImagesLoaded,
    exportMapStore: store.exportMap,
    hardLoading: store.map.hardLoading,
    layerInfos: store.layerInfos.featureLayerInfos,
    selectedExport: 'test'
  }
}
export default connect<OwnProps, DispatchProps, ParentProps>(mapStateToProps, {
  ...appExportMapDispatcher,
  ...appMapDispatcher
})(AppExportSelector)
